import {Component, EventEmitter, Input, Output, signal} from '@angular/core';
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {Tour} from "../classes/tour.model";
import {NgForOf, NgIf} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {RouterLink} from "@angular/router";
import {TourService} from "../classes/tour.service";
import {MatTooltipModule} from "@angular/material/tooltip";
import {Analytics} from "@angular/fire/analytics";
import {LanguageService} from "../classes/language.service";
import {RoleBasedDisplayDirective} from "../classes/role-based-display.directive";
import {Auth} from "@angular/fire/auth";

@Component({
  selector: 'app-tour-tile',
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    NgIf,
    MatIconModule,
    RouterLink,
    NgForOf,
    MatTooltipModule,
    RoleBasedDisplayDirective
  ],
  templateUrl: './tour-tile.component.html',
  styleUrl: './tour-tile.component.scss'
})
export class TourTileComponent {
  @Input() tour?: Tour;
  @Output() deleted: EventEmitter<void> = new EventEmitter<void>();

  get isLogged() {
    return !!this.auth.currentUser;
  }
  constructor(
    private tourService: TourService,
    private auth: Auth,
  ) {
  }

  deleteTour() {
    // Confirm deletion
    const confirm = window.confirm($localize`Are you sure you want to delete this tour?`);
    if (!confirm) {
      return;
    }

    this.tourService.deleteTour(this.tour.id).then((res) => {
      console.log('Deleted', res);
      this.deleted.emit();
    });
  }
}
